//@ts-check
import React from 'react';
import Icon from '../../core/Icon/Icon';
import { withStyles, createStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import MissingValue from '../MissingValue';
import { isSpecified } from '../util';
var styles = createStyles({
  base: {
    fontSize: 14,
    position: 'relative',
    top: 2,
    width: '1.5em',
    textAlign: 'left'
  },
  FinishedOK: {
    color: '#31ab2c'
  },
  FinishedWithErrors: {
    color: '#f10000'
  },
  Processing: {
    top: 0,
    marginRight: 4
  },
  Triggered: {
    top: 0,
    marginRight: 4
  },
  WaitingOnTask: {
    top: 0,
    marginRight: 4
  },
  WaitingForInput: {
    top: 0,
    marginRight: 4
  },
  WaitingForSignature: {
    top: 0,
    marginRight: 4
  }
}); //text associated to the response value from the server.

export var DEFAULT_STATUS_VALUES = {
  FinishedOK: 'Finished',
  FinishedWithErrors: 'Errors',
  Processing: 'In Progress',
  Triggered: 'Triggered',
  WaitingOnTask: 'Scheduled',
  WaitingForInput: 'Waiting For Input'
};
/**
 * @typedef {"FinishedOK" | "FinishedWithErrors" | "Processing" | "Triggered" | "WaitingOnTask" | "WaitingForInput" | "WaitingForSignature"} JobStatusValueType
 * @param {import('../types').FormatterProps<JobStatusValueType> & import('@material-ui/core').WithStyles<typeof styles> & {label : string}} props
 */

var JobStatusFormatter = function JobStatusFormatter(_ref) {
  var value = _ref.value,
      label = _ref.label,
      fallback = _ref.fallback,
      classes = _ref.classes;
  if (!isSpecified(value)) return fallback;
  return React.createElement(Typography, null, React.createElement(Icon, {
    type: value,
    className: classes[value] + ' ' + classes.base
  }), label || DEFAULT_STATUS_VALUES[value] || fallback);
};

JobStatusFormatter.defaultProps = {
  fallback: React.createElement(MissingValue, null)
};
export default withStyles(styles, {
  name: 'ECJobStatusFormatter'
})(JobStatusFormatter);